import Typography from '@/common/components/base/typography/Typography';

export default function WalletCountBadge({ count }: { count: number }) {
  return (
    <Typography
      textStyle={'b2'}
      bgColor={'#e9f0ff'}
      color={'blue'}
      px={6}
      borderRadius={50}
      flexShrink={0}
    >
      {count} مورد
    </Typography>
  );
}
